import HeroBanner from './components/HeroBanner';
import ProductGrid from './components/ProductGrid';

export default function Home() {
  return (
    <div>
      <HeroBanner />
      <ProductGrid />
    </div>
  );
}